import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, generatePath, useParams } from "react-router-dom";

import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import {
  // GET_ALL_PROPERTY_BY_CLIENT_ID,
  LINK_QR_CODES,
  PROPERTY_DASHBOARD_API,
  GET_CLINET_ID_API,
  GET_MAPPED_QR_LINK,
  GET_DOOR_INSPECTION_DATA,
  GET_ANONYMOUSFULL_INSPECTION_HISTORY,
  GET_ALL_DOORS_OF_INSPECTION,
} from "../api/apiPath";
import http from "../api/server";
// import { hostName } from "../config/config";
import Header from "./Header";
import Sidebar from "./Sidebar";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";
// import useGetClientId from "../hooks/useGetClientId";
import { useLocation } from "react-router-dom";
import AutocompleteInput from "./common/AutocompleteInput";
import { Statuses, UserRoles } from "./common/constant";
// import { useDispatch } from "react-redux";
import clocklogo from "../assets/img/timelogo.png";
import memlogo from "../assets/img/mlogo.png";
import StatusPill from "./common/StatusPill";
import Toaster from "./common/Toaster";
import dayjs from "dayjs";
import logo from "../assets/img/hlogo.png";
import UploadPropertyImage from "./common/UploadPropertyImage";

// import { setRefNo } from "../store/slices/refNoSlice";

export default function LinkQRcode() {
  const { clientNameParam } = useParams();
  const [hideSidebar, setHideSidebar] = useState(false);
  const navigate = useNavigate();
  const { userObj } = useSelector((state) => state.user);
  const [isAnonymous, setIsAnonymous] = useState(true);
  const [isInspector, setIsInspector] = useState(false);
  const [isLinked, setIsLinked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("new");
  const [newDoorProperty, setNewDoorProperty] = useState("");
  const [existingDoorProperty, setExistingDoorProperty] = useState("");
  // const [allPropertyList, setAllPropertyList] = useState(null);
  const [newDoorproPertyList, setNewDoorPropertyList] = useState(null);
  const [newDoorproPertyListUnique, setNewDoorPropertyListUnique] = useState(null);
  const [newDoorBuildingList, setNewDoorBuildingList] = useState(null);
  const [newDoorBuilding, setNewDoorBuilding] = useState("");
  const [existingDoorBuildingList, setExistingDoorBuildingList] = useState(null);
  const [existingDoorBuilding, setExistingDoorBuilding] = useState("");
  const [existingDoorPropertyList, setExistingDoorPropertyList] =
    useState(null);
  const [allInspectionList, setAllInspectionList] = useState(null);
  const [existingInspectionList, setExistingInspectionList] = useState(null);
  const [existinginspection, setExistingInspection] = useState("");
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showNewSurvey, setShowNewSurvey] = useState(false);
  // const { clientId } = useGetClientId();
  const [clientId, setClientId] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [doorRefOptions, setDoorRefOptions] = useState([]);
  const [doorRef, setDoorRef] = useState(null);
  const [selectedDoor, setSelectedDoor] = useState(null);
  const location = useLocation();
  const [message, setMessage] = useState("checking for linked survey...");
  const [showPropertyImageModal, setShowPropertyImageModal] = useState(false);
  // const dispatch = useDispatch();
  // const styles = {
  //   tabContainer: {
  //     display: "flex",
  //     borderBottom: "1px solid #3a4a66",
  //     marginBottom: "30px",
  //   },
  //   tabButton: (isActive) => ({
  //     padding: "10px 24px",
  //     cursor: "pointer",
  //     fontSize: "15px",
  //     fontWeight: 500,
  //     color: isActive ? "#ff6b35" : "#ccc",
  //     borderBottom: isActive ? "2px solid #ff6b35" : "2px solid transparent",
  //     background: "none",
  //     outline: "none",
  //   }),

  //   button: {
  //     backgroundColor: "#c54a2b",
  //     color: "white",
  //     border: "none",
  //     borderRadius: "6px",
  //     padding: "10px 24px",
  //     fontSize: "15px",
  //     cursor: "pointer",
  //     marginTop: "25px",
  //   },
  //   buttonHover: {
  //     backgroundColor: "#a83f25",
  //   },
  // };

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const getDeviceType = () => {
    const ua = navigator.userAgent;

    const isMobile =
      /iPhone|Android.+Mobile|Windows Phone|Opera Mini|IEMobile/i.test(ua);
    const isTablet =
      /iPad|Tablet|Nexus 7|Nexus 9|SM-T|Kindle|Silk/i.test(ua) ||
      (/Android/i.test(ua) && !/Mobile/i.test(ua)); // Android tablet

    if (isMobile || isTablet) return "mobile";
    return "desktop";
  };

  const showOpenInAppPrompt = () => {
    // Replace with your own modal if desired.
    const ok = window.confirm(
      "Press OK to open the survey in app, Cancel to continue on web.",
    );
    return Promise.resolve(ok ? "app" : "web");
  };

  const openExpoIfInstalledElseWeb = (
    urlMobile,
    fullUrlWeb,
    mappedResponse,
    isLoggedIn,
    userObj,
    opts = {},
  ) => {
    const { timeoutMs = 1200, promptOnMobile = true } = opts;

    // Basic guard
    if (!fullUrlWeb) {
      console.error("fullUrlWeb is required");
      return;
    }

    // Basic device detection
    const ua = navigator.userAgent || "";
    const isAndroid = /Android/i.test(ua);
    const isMobileOrTablet =
      /Mobi|Android|iPhone|iPad|iPod|Tablet|Windows Phone|IEMobile/i.test(ua) ||
      navigator.maxTouchPoints > 0;

    if (!isMobileOrTablet) {
      openInDesktop(mappedResponse, isLoggedIn, userObj);
      return;
    }

    // If we don't have a mobile URL, just go to web
    if (!urlMobile) {
      openInDesktop(mappedResponse, isLoggedIn, userObj);
      return;
    }

    const proceed = (choice) => {
      if (choice === "web") {
        openInDesktop(mappedResponse, isLoggedIn, userObj);
        return;
      }

      // choice === 'app': try app, then fallback to web
      let fallbackTimer;
      const goWeb = () => {
        openInDesktop(mappedResponse, isLoggedIn, userObj);
        return;
      };
      const clear = () => fallbackTimer && clearTimeout(fallbackTimer);

      const onVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
          clear();
          document.removeEventListener("visibilitychange", onVisibilityChange);
        }
      };
      document.addEventListener("visibilitychange", onVisibilityChange);

      fallbackTimer = setTimeout(goWeb, timeoutMs);

      // Attempt universal/deep link
      window.location.href = urlMobile;

      // Optional Android intent backup if universal link isn't captured
      if (isAndroid) {
        setTimeout(() => {
          try {
            const u = new URL(urlMobile);
            const intentUrl =
              `intent://${u.host}${u.pathname}${u.search}#Intent;` +
              `scheme=${u.protocol.replace(":", "")};` + // 'https' for universal links; use 'exp' if your link is exp://
              `package=host.exp.exponent;` +
              `S.browser_fallback_url=${encodeURIComponent(fullUrlWeb)};` +
              `end`;
            setTimeout(() => {
              window.location.href = intentUrl;
            }, 120);
          } catch {
            // ignore, web fallback already scheduled
          }
        }, 250);
      }
    };

    if (promptOnMobile) {
      showOpenInAppPrompt().then(proceed);
    } else {
      proceed("app"); // auto-try app without asking
    }
  };

  const openInDesktop = async (mappedResponse, isLoggedIn, userObj) => {
    const fullUrl = mappedResponse?.data?.mappedQRCodeUrl;
    const data = parseSurveyPath(fullUrl);
    let replaced;
    //check if inspection exists for the url, if yes go to view survey else go to new survey based on the url and user role
    let endpoint;
    if (isLoggedIn) {
      endpoint =
        GET_DOOR_INSPECTION_DATA +
        data?.doorNumber +
        "&propertyMasterId=" +
        data?.propertyMasterId + "&inspectionRefNumber=" + data?.inspectionRefNo;
    } else {
      endpoint =
        GET_ANONYMOUSFULL_INSPECTION_HISTORY +
        "?doorRef=" +
        data?.doorNumber +
        "&propertyMasterId=" +
        data?.propertyMasterId;
    }
    try {
      const doorData = await http.get(endpoint);
      if (doorData?.status === 200) {
        setIsLinked(true);
        setMessage("Redirecting to linked survey, please wait...");
        if (isLoggedIn) {
          replaced = fullUrl;
          handleOpenViewSurvey(replaced, userObj, doorData, data);
        } else {
          replaced = fullUrl.replace("viewSurvey", "viewSurveyAnonymous");
          const slicedPath = replaced.substring(replaced.indexOf("/client"));
          window.open(slicedPath, "_self");
        }
      }
    } catch (err) {
      if (err.status === 404) {
        setIsLinked(false);
        if (isLoggedIn) {
          checkUerRoleandRedirect(data, fullUrl, userObj);
        } else {
          setMessage(
            "The survey linked to this QR code is not yet submitted. Please contact the Inspector to submit the survey",
          );
        }
      }
    }
  };

  useEffect(() => {
    if (!userObj) {
      setIsAnonymous(true);
      handleCheckQRCodeLink(false);
    } else {
      console.log("User Object:", userObj);
      if (userObj?.isAdmin) {
        setIsInspector(true); //inspector or admin
      }
      setIsAnonymous(false);
      handleCheckQRCodeLink(true, userObj);
      // if(userObj?.isAdmin){
      //   handleCheckQRCodeLink(true);
      // }else{
      //   handleGetAllPropertyByClinetID(userObj);
      // }
    }
  }, [userObj]);

  const handleGetAllPropertyByClinetID = async (userObj) => {
    setLoading(true);
    if (userObj && userObj.userId) {
      try {
        const clientObj = await http.get(
          GET_CLINET_ID_API + "/" + userObj?.userId,
        );
        if (clientObj.status !== 200) {
          console.log(`HTTP error! status: ${clientObj.status}`);
        } else {
          setClientId(clientObj?.data?.clientId);
          setUserRole(clientObj?.data?.roleId);
          if (clientObj?.data?.roleId === UserRoles.INSPECTOR || clientObj?.data?.roleId === UserRoles.ADMIN) {
            setIsInspector(true);
          } else {
            setIsInspector(false);
          }
          console.log("Client ID:", clientId);
          const response = await http.get(
            PROPERTY_DASHBOARD_API +
              "clientId=" +
              clientObj?.data?.clientId +
              "&userId=" +
              userObj.userId,
          );
          if (response.status === 200) {
            const properties = response?.data?.propertyFields;
            properties.forEach((item) => {
              item.id = item.inspectionMasterId;
            });
            // setAllPropertyList(properties);
            const newDoorProperties = properties.filter(
              (property) =>
                property.status === Statuses.SCHEDULED ||
                property.status === Statuses.INPROGRESS,
            );
            const newSurveyAllowedProperties = newDoorProperties.filter(
              (property) => {
                const scheDate = new Date(property?.scheduledInspectionDate);
                const todayDate = new Date();

                // Normalize to date-only strings
                const d1 = dayjs(scheDate).format("YYYY-MM-DD");
                const d2 = dayjs(todayDate).format("YYYY-MM-DD");

                // Compare as strings
                const isBeforeOrSame = d1 <= d2;
                const withinLastYear = new Date(property.scheduledInspectionDate).getFullYear() > new Date().getFullYear() - 1
                
                return isBeforeOrSame && withinLastYear;
              },
            );
            setNewDoorPropertyList(newSurveyAllowedProperties);
            const uniqueByIdNew = (newSurveyAllowedProperties) => {
              const map = new Map();
              for (const obj of newSurveyAllowedProperties)
                map.set(obj.propertyMasterId, obj);
              return [...map.values()];
            };
            const resultNew = uniqueByIdNew(newSurveyAllowedProperties);
            setNewDoorPropertyListUnique(resultNew);

            const ExistingDoorProperties = properties.filter(
              (property) =>
                property.status !== Statuses.SCHEDULED &&
                property.status !== Statuses.NEW &&
                property.status !== Statuses.PENDINGINSPECTORAPPROVAL,
            );
            setAllInspectionList(ExistingDoorProperties);

            const uniqueById = (ExistingDoorProperties) => {
              const map = new Map();
              for (const obj of ExistingDoorProperties)
                map.set(obj.propertyMasterId, obj);
              return [...map.values()];
            };

            const result = uniqueById(ExistingDoorProperties);

            setExistingDoorPropertyList(result);
            console.log("prop list", ExistingDoorProperties, result);
          }
        }
      } catch (error) {
        console.log("Error fetching all properties:", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    }
  };

  const handleCheckQRCodeLink = async (isLoggedIn, userObj) => {
    const queryParams = new URLSearchParams(location.search);
    const refNo = queryParams.get("refNo");
    if (refNo) {
      try {
        const mappedResponse = await http.get(
          GET_MAPPED_QR_LINK + "?qrCodeRefNo=" + refNo,
        );
        console.log("Mapped QR Link Response:", mappedResponse);
        if (mappedResponse.status === 200) {
          setIsLinked(true);

          //check if mobile/web

          const deviceType = getDeviceType();
          if (deviceType === "mobile") {
            const fullUrlWeb = mappedResponse?.data?.mappedQRCodeUrl;
            const urlMobile = mappedResponse?.data?.mobileMappedQRCodeUrl;
            openExpoIfInstalledElseWeb(
              urlMobile,
              fullUrlWeb,
              mappedResponse,
              isLoggedIn,
              userObj,
              {
                timeoutMs: 1200,
                promptOnMobile: true,
              },
            );
          } else {
            openInDesktop(mappedResponse, isLoggedIn, userObj);
          }
        }
        if (!mappedResponse.status) {
          if (isLoggedIn) {
            handleGetAllPropertyByClinetID(userObj);
          }
          setTimeout(() => {
            setIsLinked(false);
            setMessage(
              "The QR code has not been linked to any existing inspection. Please contact the Inspector to link the same",
            );
          }, 500);
        }
      } catch (error) {
        console.error("Error checking QR code link:", error);
        if (isLoggedIn) {
          handleGetAllPropertyByClinetID(userObj);
        }
        setTimeout(() => {
          setIsLinked(false);
          setMessage(
            "The QR code has not been linked to any existing inspection. Please contact the Inspector to link the same",
          );
        }, 500);
      } finally {
        setLoading(false);
      }
    }
  };

  const checkUerRoleandRedirect = async (data, fullUrl, userObj) => {
    try {
      const clientObj = await http.get(
        GET_CLINET_ID_API + "/" + userObj?.userId,
      );
      const response = await http.get(
        PROPERTY_DASHBOARD_API +
          "clientId=" +
          clientObj?.data?.clientId +
          "&userId=" +
          userObj.userId,
      );
      if (response?.status === 200) {
        const property = response?.data?.propertyFields?.filter(
          (p) => p.inspectionReferenceNumber === data?.inspectionRefNo,
        )?.[0];
        console.log("Property for QR code inspection:", property);
        if (property === undefined || property === null) {
          setMessage(
            "You are not authorized to view this survey.",
          );
        } else {
          if (clientObj?.data?.roleId === UserRoles.INSPECTOR || clientObj?.data?.roleId === UserRoles.ADMIN) {
            setMessage("Redirecting to New Survey, please wait...");
            const replaced = fullUrl.replace("viewSurvey", "dashboard");
            const slicedPath = replaced.substring(replaced.indexOf("/client"));
            window.open(slicedPath, "_self");
          } else {
            setMessage(
              "The survey linked to this QR code is not yet submitted. Please contact the Inspector to submit the survey",
            );
          }
        }
      }
    } catch (err) {
      console.error("Error checking user role and redirecting:", err);
    }
  };

  const handleOpenViewSurvey = async (replaced, userObj, doorData, urlData) => {
    setLoading(true);
    // if (userObj?.isAdmin) {
    //   const slicedPath = replaced.substring(replaced.indexOf("/client"));
    //   window.open(slicedPath, "_self");
    // } else {
      //check if assigned inspector
      if (
        doorData?.data?.propertyInfo?.inspectedBy?.toLowerCase() ==
        userObj?.userEmail?.toLowerCase() || userObj?.isAdmin
      ) {
        //check inspection status
        try {
          const clientObj = await http.get(
            GET_CLINET_ID_API + "/" + userObj?.userId,
          );
          if (clientObj?.status === 200) {
            const response = await http.get(
              PROPERTY_DASHBOARD_API +
                "clientId=" +
                clientObj?.data?.clientId +
                "&userId=" +
                userObj.userId,
            );
            if (response?.status === 200) {
              const property = response?.data?.propertyFields?.filter(
                (p) => p.inspectionReferenceNumber === urlData?.inspectionRefNo,
              )?.[0];
              if (property === undefined || property === null) {
                setMessage("You are not authorized to view this Survey.");
              } else if (property?.status === Statuses.INPROGRESS || property?.status === Statuses.REJECTED) {
                const newreplaced = replaced.replace(
                  "viewSurvey",
                  "editSurvey",
                );
                const slicedPath = newreplaced.substring(
                  newreplaced.indexOf("/client"),
                );
                window.open(slicedPath, "_self");
              } else {
                const slicedPath = replaced.substring(
                  replaced.indexOf("/client"),
                );
                window.open(slicedPath, "_self");
              }
            }
          }
        } catch (err) {
          console.error("Error fetching client ID:", err);
        }
      } else {
        //check if approver
        try {
          const clientObj = await http.get(
            GET_CLINET_ID_API + "/" + userObj?.userId,
          );
          if (clientObj?.status === 200) {
            const response = await http.get(
              PROPERTY_DASHBOARD_API +
                "clientId=" +
                clientObj?.data?.clientId +
                "&userId=" +
                userObj.userId,
            );
            if (response?.status === 200) {
              const property = response?.data?.propertyFields?.filter(
                (p) => p.inspectionReferenceNumber === urlData?.inspectionRefNo,
              )?.[0];
              if (property === undefined || property === null) {
                setMessage(
                  "You are not authorized to view this survey.",
                );
              } else if (
                property?.approverIds?.includes(userObj?.userId.toString()) &&
                (property?.status === Statuses.SUBMITTEDFORAPPROVAL ||
                  property?.status === Statuses.COMPLETED ||
                  property?.status === Statuses.REJECTED)
              ) {
                const slicedPath = replaced.substring(
                  replaced.indexOf("/client"),
                );
                window.open(slicedPath, "_self");
              } else {
                setMessage("You are not authorized to view this Survey.");
              }
            }
          }
        } catch (err) {
          console.error("Error during authorization check:", err);
        } finally {
          setLoading(false);
        }
      // }
    }
  };

  const parseSurveyPath = (pathname) => {
    // Normalize and ensure we look after "/viewSurvey/"
    const marker = "/viewSurvey/";
    const idx = pathname.toLowerCase().indexOf(marker.toLowerCase());
    if (idx === -1) return null;

    // Take everything after /viewSurvey/
    const rest = pathname.slice(idx + marker.length);

    // In case there are query strings or hashes (rare for path usage)
    const cleaned = rest.split(/[?#]/)[0];

    // Now split into segments
    const [propertyMasterId, inspectionRefNo, doorNumber] = cleaned.split("/");

    if (!propertyMasterId || !inspectionRefNo || !doorNumber) return null;

    return { propertyMasterId, inspectionRefNo, doorNumber };
  };

  const handleNewDoorPropertyChange = (val, site) => {
    setNewDoorProperty(val);
    setNewDoorBuilding("");
    // handleSetSelectedProperty(site);

    const tempBUildingList = newDoorproPertyList.filter(x => x.propertyMasterId === site?.propertyMasterId && x.buildingId !== null) || [];
    if(tempBUildingList.length === 0){
      handleSetSelectedProperty(site);
      setNewDoorBuildingList([]);
    }else{
      handleSetSelectedProperty();
      setNewDoorBuildingList(tempBUildingList);
    }

    console.log("Selected country:", val, site);
  };
  
  const handleNewDoorBuildingChange = (val, site) => {
    setNewDoorBuilding(val);
    handleSetSelectedProperty(site);
  }

  const handleExistingDoorPropertyChange = (val, site) => {
    const selectedProperty = val;
    setExistingDoorProperty(selectedProperty);
    setExistingDoorBuilding("");

    const inspptions = allInspectionList.filter(
      (x) => x.propertyMasterId === selectedProperty && x.buildingId !== null,
    );
    
    const uniqueByBuildingId = [
      ...new Map(inspptions.map(item => [item.buildingId, item])).values()
    ];


    if(uniqueByBuildingId.length === 0){
      const inspptionsOnly = allInspectionList.filter(
      (x) => x.propertyMasterId === selectedProperty,
    );
      setExistingInspectionList(inspptionsOnly);
      setExistingDoorBuildingList([]);
    }else{
      setExistingDoorBuildingList(uniqueByBuildingId)
    }

    console.log("Selected site:", selectedProperty, site, inspptions);
  };

  const handleExistingDoorBuildingChange = (val, site) => {
    setExistingDoorBuilding(val);
    const inspptions = allInspectionList.filter(
      (x) => x.propertyMasterId === site.propertyMasterId && x.buildingId === site.buildingId,
    );
    setExistingInspectionList(inspptions);
  }

  const handleExistingInspectionChange = (val, site) => {
    setLoading(true);
    const selectedProperty = val;
    setExistingInspection(selectedProperty);
    handleSetSelectedProperty(site);
    handleGetAllDoorRefs(site);
    console.log("Selected country:", selectedProperty, site);
  };

  const handleSetSelectedProperty = (property) => {
    setSelectedProperty(property);
    if (property) {
      const scheDate = new Date(property?.scheduledInspectionDate);
      const todayDate = new Date();

      // Normalize to date-only strings
      const d1 = dayjs(scheDate).format("YYYY-MM-DD");
      const d2 = dayjs(todayDate).format("YYYY-MM-DD");

      // Compare as strings
      const isBeforeOrSame = d1 <= d2;
      if (
        (userRole === UserRoles.INSPECTOR || userRole === UserRoles.ADMIN) &&
        (property?.status === Statuses.SCHEDULED ||
          property?.status === Statuses.INPROGRESS) &&
        isBeforeOrSame &&
        new Date(property.scheduledInspectionDate).getFullYear() >
          new Date().getFullYear() - 1
      ) {
        setShowNewSurvey(true);
      } else {
        setShowNewSurvey(false);
      }
    } else {
      setShowNewSurvey(false);
    }
  };

  const handleGetAllDoorRefs = async (property) => {
    try {
      // const response = await http.get(
      //   `${GET_PROPERTY_COMPLIANCE_SUMMARY}` +
      //     `?propertyMasterId=${encodeURIComponent(property?.propertyMasterId)}` +
      //     `&inspectionReferenceNumber=${encodeURIComponent(property?.inspectionReferenceNumber)}` +
      //     `&userId=${encodeURIComponent(userObj?.userId)}`,
      // );
      const doorsResponse = await http.get(GET_ALL_DOORS_OF_INSPECTION, {
                  params:{
                    inspectionRefNumber: property?.inspectionReferenceNumber,
                    propertyMasterId: property?.propertyMasterId
                  }
                });
      if (doorsResponse.status === 200) {
        const data = doorsResponse?.data || [];
        data.forEach((item) => {
          item.id = item.inspectedDoorID;
        });
        setDoorRefOptions(data);
      }
    } catch (err) {
      console.error("Error fetching door references:", err);
      setDoorRefOptions([]);
    } finally {
      setLoading(false);
    }
  };

  // const saveQRCodeRefNoInRedux = () => {
  // const queryParams = new URLSearchParams(location.search);
  // const refNo = queryParams.get("refNo");
  //   if (refNo) {
  //     // dispatch(setRefNo(refNo));
  //     console.log("✅ Saved refNo in Redux:", refNo);
  //   } else {
  //     console.warn("⚠️ refNo not found in URL");
  //   }
  // };

  const handleLinkNewQRCode = async () => {
    setLoading(true);
    const queryParams = new URLSearchParams(location.search);
    const refNo = queryParams.get("refNo");
    const params = new URLSearchParams();
    params.append("PropertyId", selectedProperty?.propertyMasterId);
    if(selectedProperty?.buildingId){
      params.append("BuildingId", selectedProperty?.buildingId);
    }
    params.append(
      "InspectionRefNo",
      selectedProperty?.inspectionReferenceNumber,
    );
    params.append("QRCodeRefNo", refNo);
    params.append("loggedinUserId", userObj?.userId || 0);

    const queryString = params.toString();

    try {
      const response = await http.put(LINK_QR_CODES + `?${queryString}`);
      console.log("Link QR Code Response:", response);
      if (response?.status === 200) {
        const data = response?.data;
        // setApiDoorRef('UC-PS-DRN-0000')
        if (data?.doorMapped && data?.doorRefNo != "") {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "QR Code linked successfully. Please start the survey",
          });
          if (showNewSurvey) {
            setTimeout(() => {
              gotoDashBoardLinked(data?.doorRefNo);
            }, 2001);
          }
        } else if (data?.doorMapped === false && data?.mapppedUrl != "") {
          try {
            const doorData = await http.get(
              GET_DOOR_INSPECTION_DATA +
                data?.doorRefNo +
                "&propertyMasterId=" +
                selectedProperty?.propertyMasterId + "&inspectionRefNumber=" + data?.inspectionRefNo,
            );
            if (doorData?.status === 200) {
              setToastData({
                toastShow: true,
                toastType: "success",
                toastString:
                  "An inspection for this door already exists, redirecting to edit survey",
              });
              setTimeout(() => {
                gotoEditSurvey(data?.doorRefNo, data?.mapppedUrl);
              }, 2001);
            }
          } catch (err) {
            if (err.status === 404) {
              setToastData({
                toastShow: true,
                toastType: "success",
                toastString:
                  "QR Code already linked to door. Redirecting to new survey for the same",
              });
              if (showNewSurvey) {
                setTimeout(() => {
                  gotoDashBoardMapped(data?.doorRefNo, data?.mapppedUrl);
                }, 2001);
              }
            }
          }
        }
      }
    } catch (err) {
      console.error("Link QR Code Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const gotoDashBoardLinked = (doorRef) => {
    const pathTemplate =
      "/client/:clientNameParam/dashboard/:propertyMasterId/:inspectionRefnumber/:doorRefNumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: selectedProperty?.propertyMasterId,
      inspectionRefnumber: selectedProperty?.inspectionReferenceNumber,
      doorRefNumber: doorRef,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const gotoDashBoardMapped = (doorRef, mappedUrl) => {
    const urlTouse = mappedUrl.split("/viewSurvey/")[1];
    const pathTemplate = `/client/:clientNameParam/dashboard/${urlTouse}`;
    const params = {
      clientNameParam: clientNameParam,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const gotoEditSurvey = (doorRef, mappedUrl) => {
    const urlTouse = mappedUrl.split("/viewSurvey/")[1];
    const pathTemplate = `/client/:clientNameParam/editSurvey/${urlTouse}`;
    const params = {
      clientNameParam: clientNameParam,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const gotoViewSurvey = (doorRef, mappedUrl) => {
    const urlTouse = mappedUrl?.split("/viewSurvey/")[1];
    const pathTemplate = `/client/:clientNameParam/viewSurvey/${urlTouse}`;
    const params = {
      clientNameParam: clientNameParam,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const handleLinkExistingQRCode = async () => {
    setLoading(true);
    const queryParams = new URLSearchParams(location.search);
    const refNo = queryParams.get("refNo");
    const params = new URLSearchParams();
    params.append("PropertyId", selectedProperty?.propertyMasterId);
    if(selectedProperty?.buildingId){
      params.append("BuildingId", selectedProperty?.buildingId);
    }
    params.append(
      "InspectionRefNo",
      selectedProperty?.inspectionReferenceNumber,
    );
    params.append("QRCodeRefNo", refNo);
    params.append("loggedinUserId", userObj?.userId || 0);
    params.append("DoorRefNo", doorRef);

    const queryString = params.toString();

    try {
      const response = await http.put(LINK_QR_CODES + `?${queryString}`);
      console.log("Link QR Code Response:", response);
      if (response?.status === 200) {
        const data = response?.data;
        // setApiDoorRef('UC-PS-DRN-0000')
        if (data?.doorMapped && data?.doorRefNo != "") {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString:
              "QR Code linked successfully. redirecting to view Survey",
          });

          setTimeout(() => {
            gotoViewSurvey(data?.doorRefNo, data?.mapppedUrl);
          }, 2001);
        } else if (data?.doorMapped === false && data?.doorRefNo != "") {
          try {
            const doorData = await http.get(
              GET_DOOR_INSPECTION_DATA +
                data?.doorRefNo +
                "&propertyMasterId=" +
                selectedProperty?.propertyMasterId + "&inspectionRefNumber=" + data?.inspectionRefNo,
            );
            if (doorData?.status === 200) {
              setToastData({
                toastShow: true,
                toastType: "success",
                toastString:
                  "An inspection for this door already exists, redirecting to edit survey",
              });
              setTimeout(() => {
                gotoViewSurvey(data?.doorRefNo, data?.mapppedUrl);
              }, 2001);
            }
          } catch (err) {
            if (err.status === 404) {
              setToastData({
                toastShow: true,
                toastType: "success",
                toastString:
                  "QR Code already linked to door. Redirecting to new survey for the same",
              });

              setTimeout(() => {
                gotoViewSurvey(data?.doorRefNo, data?.mapppedUrl);
              }, 2001);
            }
          }
        }
      }
    } catch (err) {
      console.error("Link QR Code Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveNewDoor = () => {
    //check if property image upoladed for first time
    if (!selectedProperty?.buildingImage) {
      setShowPropertyImageModal(true);
    } else {
      handleLinkNewQRCode();
    }
  };

  const handleCancel = () => {
    setShowPropertyImageModal(false);
    // setShowPropertyImageDetails(null);
  };

  const handleUploadPropertySuccess = () => {
    setShowPropertyImageModal(false);
    handleLinkNewQRCode();
  };

  const handleSaveExistingDoor = () => {
    handleLinkExistingQRCode();
  };

  const resetDoorSelection = () => {
    setDoorRef(null);
    setSelectedDoor(null);
  };

  const resetInspectionSelection = () => {
    setExistingInspection("");
    setExistingInspectionList(null);
    setSelectedDoor(null);
    handleSetSelectedProperty(null);
  };

  const resetPropertySelection = () => {
    handleSetSelectedProperty(null);
    setNewDoorProperty("");
    setExistingDoorProperty("");
    setDoorRefOptions([]);
  };

  const handleBack = () => {
    const fallback = generatePath("/client/:clientNameParam/property-form", {
      clientNameParam,
    });
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.replace(fallback);
    }
  };

  return (
    <>
      {!isAnonymous && (
        <div>
          <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
        </div>
      )}
      {!isAnonymous && (
        <div className="dashboard_body_main vh-100">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          {/* Tabs */}
          {showPropertyImageModal && (
            <UploadPropertyImage
              propertyId={selectedProperty?.propertyMasterId}
              handleCancel={handleCancel}
              propertyName={selectedProperty?.propertyName}
              inspectionRefnumber={selectedProperty?.inspectionReferenceNumber}
              handleSuccess={handleUploadPropertySuccess}
            />
          )}
          {!isInspector && !isLinked && (
            <div className="d-flex dashboard_body flex-column align-items-center py-1 w-100 mt-2">
              <p className="text-start mt-5">{message}</p>
              <button
                className="btn-primary col-6 col-sm-6 col-md-3"
                onClick={() => {
                  handleBack();
                }}
              >
                Back
              </button>
            </div>
          )}
          {isLinked && (
            <div className="d-flex dashboard_body flex-column align-items-center py-1 w-100 mt-2">
              <p className="text-start mt-5">{message}</p>
              <button
                className="btn-primary col-6 col-sm-6 col-md-3"
                onClick={() => {
                  handleBack();
                }}
              >
                Back
              </button>
            </div>
          )}
          {isInspector && (
            <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
              <div className="dashboard_header">
                <div>
                  <h2 className="mb-0">Link QR Code</h2>
                  <p className="header-description mb-0">
                    Link new QR Code with door.
                  </p>
                </div>
              </div>
              <div className=" mt-3 mb-3 tab-container">
                <button
                  className={
                    activeTab === "new" ? "btn btn-tab-active" : "btn btn-tab"
                  }
                  onClick={() => {
                    setActiveTab("new");
                    resetPropertySelection();
                    resetInspectionSelection();
                    resetDoorSelection();
                  }}
                >
                  New Door
                </button>
                <button
                  className={
                    activeTab === "existing"
                      ? "btn btn-tab-active"
                      : "btn btn-tab"
                  }
                  onClick={() => {
                    setActiveTab("existing");
                    resetPropertySelection();
                    resetInspectionSelection();
                    resetDoorSelection();
                  }}
                >
                  Existing Door
                </button>
              </div>

              {/* Tab Content */}
              {activeTab === "new" ? (
                <>
                  <div className="card-body-section">
                    <div className="form-group">
                    <label htmlFor={`property`}>
                      Site Name <span className="label-star">*</span>
                    </label>
                    <AutocompleteInput
                      // masterList={city || []}
                      masterList={[...(newDoorproPertyListUnique || [])].sort(
                        (a, b) =>
                          (a.propertyName || "").localeCompare(
                            b.propertyName || "",
                            undefined,
                            {
                              sensitivity: "base",
                            },
                          ),
                      )}
                      className="form-select"
                      getOptionLabel={(c) => c?.propertyName || ""}
                      getOptionValue={(c) => c?.inspectionReferenceNumber || ""}
                      value={newDoorProperty}
                      onValueChange={(val, site) => {
                        console.log(val, site);
                        handleNewDoorPropertyChange(val, site);
                      }}
                      placeholder="Select Site"
                      inputClassName=""
                      wrapperClassName=""
                      notFoundText="Site not found"
                      inputId={`property`}
                      // inputRef={(el) => (cityRef.current[entry.id] = el)}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor={`building`}>
                      Building Name <span className="label-star">*</span>
                    </label>
                    <AutocompleteInput
                      // masterList={city || []}
                      masterList={[...(newDoorBuildingList || [])].sort(
                        (a, b) =>
                          (a.buildingName || "").localeCompare(
                            b.buildingName || "",
                            undefined,
                            {
                              sensitivity: "base",
                            },
                          ),
                      )}
                      className="form-select"
                      getOptionLabel={(c) => c?.buildingName || ""}
                      getOptionValue={(c) => c?.inspectionReferenceNumber || ""}
                      value={newDoorBuilding}
                      disabled={newDoorBuildingList?.length === 0}
                      onValueChange={(val, site) => {
                        console.log(val, site);
                        handleNewDoorBuildingChange(val, site);
                      }}
                      placeholder="Select Building"
                      inputClassName=""
                      wrapperClassName=""
                      notFoundText="Building not found"
                      inputId={`property`}
                      // inputRef={(el) => (cityRef.current[entry.id] = el)}
                    />
                  </div>
                  </div>
                  


                  {selectedProperty && (
                    <div className="resident-card mb-3 mt-4">
                      <div className="flex-sm-row align-items-center">
                        <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <h5 className="justifyStart fw-bold mb-0">
                              {selectedProperty?.buildingName === null ? selectedProperty?.propertyName : selectedProperty?.buildingName ||
                                "Property Name"}
                            </h5>

                            <p className="justifyCenter mb-0 mt-1">
                              <StatusPill
                                status={selectedProperty?.status || ""}
                              />
                            </p>
                          </div>

                          <p className="justifyStart text mb-0 mt-1">
                            {/* <b>Location</b>:{" "} */}
                            {selectedProperty?.buildingName === null ? selectedProperty?.propertyLocation : selectedProperty?.propertyName + `, ` + selectedProperty?.propertyLocation || ""}
                          </p>

                          <div className="d-flex justify-content-between align-items-center w-100 mt-4 mb-4 text-black fw-semibold">
                            {/* Inspector */}
                            <p className="d-flex align-items-center mb-0 gap-2">
                              <img
                                src={memlogo} // replace with your image path
                                alt="Inspector"
                                width="16"
                                height="16"
                              />
                              <span className="info-label">Inspector:</span>
                              <span className="info-value">
                                {selectedProperty?.inspectedBy || ""}
                              </span>
                            </p>

                            {/* Submitted Date */}
                            <p className="d-flex align-items-center mb-0 gap-2">
                              <img
                                src={clocklogo} // replace with your image path
                                alt="Date"
                                width="16"
                                height="16"
                              />
                              <span className="info-label">
                                Scheduled Date:
                              </span>
                              <span className="info-value">
                                {selectedProperty?.scheduledInspectionDate
                                  ? new Date(
                                      selectedProperty.scheduledInspectionDate,
                                    ).toLocaleDateString("en-GB", {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    })
                                  : ""}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="button-container">
                    <button
                      disabled={!selectedProperty}
                      className="btn-primary col-12 col-sm-6 col-md-3"
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#a83f25")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#c54a2b")
                      }
                      onClick={() => {
                        handleSaveNewDoor();
                      }}
                    >
                      {showNewSurvey ? "Link Door" : "Link Door"}
                    </button>
                    <button
                      type="button"
                      className="btn-secondary col-12 col-sm-6 col-md-3"
                      onClick={() => {
                        navigate(
                          generatePath(
                            "/client/:clientNameParam/property-form",
                            {
                              clientNameParam,
                            },
                          ),
                        );
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              ) : (
                <>
                <div className="card-body-section">

                
                  <div className="form-group mb-2">
                    <label htmlFor={`property`}>
                      Site Name <span className="label-star">*</span>
                    </label>
                    <AutocompleteInput
                      // masterList={city || []}
                      masterList={[...(existingDoorPropertyList || [])].sort(
                        (a, b) =>
                          (a.propertyName || "").localeCompare(
                            b.propertyName || "",
                            undefined,
                            {
                              sensitivity: "base",
                            },
                          ),
                      )}
                      className="form-select"
                      getOptionLabel={(c) => c?.propertyName || ""}
                      getOptionValue={(c) => c?.propertyMasterId || ""}
                      value={existingDoorProperty}
                      onValueChange={(val, site) => {
                        console.log(val, site);
                        resetDoorSelection();
                        resetInspectionSelection();
                        handleExistingDoorPropertyChange(val, site);
                      }}
                      placeholder="Select Site"
                      inputClassName=""
                      wrapperClassName=""
                      notFoundText="Site not found"
                      inputId={`property`}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor={`building`}>
                      Building Name <span className="label-star">*</span>
                    </label>
                    <AutocompleteInput
                      // masterList={city || []}
                      masterList={[...(existingDoorBuildingList || [])].sort(
                        (a, b) =>
                          (a.buildingName || "").localeCompare(
                            b.buildingName || "",
                            undefined,
                            {
                              sensitivity: "base",
                            },
                          ),
                      )}
                      className="form-select"
                      getOptionLabel={(c) => c?.buildingName || ""}
                      getOptionValue={(c) => c?.inspectionReferenceNumber || ""}
                      value={existingDoorBuilding}
                      disabled={existingDoorBuildingList?.length === 0}
                      onValueChange={(val, site) => {
                        console.log(val, site);
                        resetInspectionSelection();
                        handleExistingDoorBuildingChange(val, site);
                      }}
                      placeholder="Select Building"
                      inputClassName=""
                      wrapperClassName=""
                      notFoundText="Building not found"
                      inputId={`property`}
                      // inputRef={(el) => (cityRef.current[entry.id] = el)}
                    />
                  </div>
                </div>

                  <div className="form-group mb-2">
                    <label htmlFor={`property`}>
                      Inspection Reference Number
                      <span className="label-star">*</span>
                    </label>
                    <AutocompleteInput
                      masterList={[...(existingInspectionList || [])]}
                      className="form-select"
                      getOptionLabel={(c) => c?.inspectionReferenceNumber || ""}
                      getOptionValue={(c) => c?.inspectionReferenceNumber || ""}
                      value={existinginspection}
                      onValueChange={(val, site) => {
                        console.log(val, site);
                        resetDoorSelection();
                        resetInspectionSelection();
                        handleExistingInspectionChange(val, site);
                      }}
                      placeholder="Select Inspection"
                      inputClassName=""
                      wrapperClassName=""
                      notFoundText="Inspection not found"
                      inputId={`inspection`}
                    />
                  </div>

                  {selectedProperty && (
                    <div className="resident-card mb-2">
                      <div className="flex-sm-row align-items-center ">
                        <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <h5 className="justifyStart fw-bold mb-0">
                              {selectedProperty?.buildingName === null ? selectedProperty?.propertyName : selectedProperty?.buildingName ||
                                "Property Name"}
                            </h5>

                            <p className="justifyCenter mb-0 mt-1">
                              <StatusPill
                                status={selectedProperty?.status || ""}
                              />
                            </p>
                          </div>

                          <p className="justifyStart text mb-0 mt-1">
                            {/* <b>Location</b>:{" "} */}
                            {selectedProperty?.buildingName === null ? selectedProperty?.propertyLocation : selectedProperty?.propertyName + `, ` + selectedProperty?.propertyLocation || ""}
                          </p>

                          <div className="d-flex justify-content-between align-items-center w-100 mt-3 text-black fw-semibold">
                            {/* Inspector */}
                            <p className="d-flex align-items-center mb-0 gap-2">
                              <img
                                src={memlogo} // replace with your image path
                                alt="Inspector"
                                width="16"
                                height="16"
                              />
                              <span className="info-label">Inspector:</span>
                              <span className="info-value">
                                {selectedProperty?.inspectedBy || ""}
                              </span>
                            </p>

                            {/* Submitted Date */}
                            <p className="d-flex align-items-center mb-0 gap-2">
                              <img
                                src={clocklogo} // replace with your image path
                                alt="Date"
                                width="16"
                                height="16"
                              />
                              <span className="info-label">
                                Scheduled Date:
                              </span>
                              <span className="info-value">
                                {selectedProperty?.scheduledInspectionDate
                                  ? new Date(
                                      selectedProperty.scheduledInspectionDate,
                                    ).toLocaleDateString("en-GB", {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    })
                                  : ""}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="form-group mb-2">
                    <label htmlFor={`doorref`}>
                      Door Reference Number{" "}
                      <span className="label-star">*</span>
                    </label>
                    <select
                      className="form-select"
                      value={doorRef || ""}
                      placeholder="Select Door Reference Number"
                      onChange={(e) => {
                        setDoorRef(e.target.value);
                        const selectedDoor = doorRefOptions.find(
                          (door) => door.DoorReferenceNumber === e.target.value,
                        );
                        setSelectedDoor(selectedDoor);
                      }}
                    >
                      <option value={""}>Select Door</option>
                      {doorRefOptions?.map((door, index) => (
                        <option key={index} value={door.DoorReferenceNumber}>
                          {door.DoorReferenceNumber}
                        </option>
                      ))}
                    </select>
                  </div>
                  {selectedDoor && (
                    <div className="resident-card">
                      <div className="flex-sm-row align-items-center ">
                        <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <p className="justifyStart text mb-0 mt-1">
                              {/* <b>Location</b>:{" "} */}
                              {`Door ${selectedDoor?.DoorReferenceNumber}` ||
                                ""}
                            </p>

                            <p className="justifyCenter mb-0 mt-1">
                              <StatusPill status={selectedDoor?.Status || ""} />
                            </p>
                          </div>

                          
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="button-container">
                    <button
                      disabled={!selectedProperty || !doorRef}
                      className="btn-primary col-12 col-sm-6 col-md-3"
                      onClick={() => {
                        handleSaveExistingDoor();
                      }}
                    >
                      Link Door
                    </button>
                    <button
                      type="button"
                      className="btn-secondary col-12 col-sm-6 col-md-3"
                      onClick={() => {
                        navigate(
                          generatePath(
                            "/client/:clientNameParam/property-form",
                            {
                              clientNameParam,
                            },
                          ),
                        );
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={() => {
              closeButton();
            }}
          />
          <Footer />
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
        </div>
      )}
      {isAnonymous && (
        <>
          <div>
            <nav className="navbar navbar-expand-lg bg-light border-bottom dashboard_nav p-0">
              <div
                className="d-flex align-items-center"
                style={{
                  backgroundColor: "white",
                  height: "68px",
                  position: "fixed",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.25)",
                  left: "0",
                  right: "0",
                  top: "0",
                  paddingLeft: "20px",
                }}
              >
                <img src={logo} className="logoheader ms-0" alt="logo" />
                <p className="mt-4 ms-2 fw-semibold">FIRE INSPECT </p>
              </div>
            </nav>
          </div>
          <div
            className="dashboard_body_main d-flex align-items-center"
            style={{ paddingTop: "20px" }}
          >
            <p className="text-center align-items-center mt-5">{message}</p>
            <button
              className="btn-primary col-6 col-sm-6 col-md-3"
              onClick={() => {
                if (clientNameParam) {
                  navigate(
                    generatePath("/client/:clientNameParam", {
                      clientNameParam,
                    }),
                    { replace: true },
                  );
                } else {
                  navigate("/client");
                }
              }}
            >
              Go to Login
            </button>
          </div>
        </>
      )}
      <LoadingComponent loading={loading} />
    </>
  );
}
